import axios from "axios";
import { calculateFileSize, getWorkWiseAuthToken } from "../Utils/helper";
import { setSavingData } from "../Reducers/documentInfoSlice";

export const workwiseUrl = "https://workw.com/workwapi/api";
const workwiseHeaders = { 'Authorization': `Bearer ${getWorkWiseAuthToken()}` };
let debounceTimeout;

export const workwiseServices = {
  async getDocumentById(id) {
    const dummyResponse = {
      status: 200,
      data: {
        data: {
          rightType: 2,
          members: [],
          name: "Dummy",
          creator: {
            id: "dss",
            name: "YUP",
            image: "tt"
          },
          createBy: "dsds"

        }
      }
    }

    // return dummyResponse;

    return axios.get(
      `${workwiseUrl}/Authorize/Authorize?id=${id}`,
      { headers: workwiseHeaders });
  },
  async getAllSuggestion(payload) {
    return axios.post(
      `${workwiseUrl}/Suggestion/GetAllSuggestion`,
      payload,
      { headers: workwiseHeaders });
  },
  async addDocumentMember(id, payload) {
    return axios.post(
      `${workwiseUrl}/Document/AddDocumentMember?id=${id}`,
      payload,
      { headers: workwiseHeaders });
  },
  async shareDocumentToAnyone(payload) {
    return axios.post(`${workwiseUrl}/Document/UpdateDocument`,
      payload,
      { headers: workwiseHeaders }
    )
  },
  async saveDocumentlastUpdate(id, dispatch, data) {
    if (!dispatch) {
      return;
    }
    const currentDate = new Date();
    const formattedDate = currentDate.toLocaleString();
    const size = calculateFileSize(data);
    if (setSavingData) {
      dispatch(setSavingData({ isSaving: 'Saving...', lastSavedDateTime: '' }));

      await new Promise(resolve => setTimeout(resolve, 800));

      dispatch(setSavingData({
        isSaving: 'Saved',
        lastSavedDateTime: formattedDate,
        fileSize: size
      }));
    }

    if (debounceTimeout) {
      clearTimeout(debounceTimeout);
    }

    debounceTimeout = setTimeout(async () => {
      try {
        await axios.post(`${workwiseUrl}/Document/SaveDocumentAttachment?attachmentId=${id}&fileSize=${size}`,
          {},
          { headers: workwiseHeaders }
        );
        // Handle the response if needed
      } catch (e) {
        console.error("error", e);
      }
    }, 5000);
  },
  async completeDocument(id) {
    try {
      const formData = new FormData();
      formData.append('id', id);
      return await axios.post(`${workwiseUrl}/Document/CompleteDocument?id=${id}`,
        formData,
        { headers: workwiseHeaders }
      );
      // Handle the response if needed
    } catch (error) {
      return error;
    }
  }
};